<div id="comments-create-form" class="bg-white rounded-lg mt-3 p-3">
  <div class="flex gap-2">
    @if (currentUser) {
      <avatar-icon [user]="currentUser"/>
    }
    <div class="w-full mb-4 rounded-lg border border-gray-500">
      <div class="px-4 py-2 bg-gray-50 rounded-lg">
        <label for="comments-textarea" class="sr-only">Your comment</label>
        @if (!editCommentId) {
          <textarea
            [(ngModel)]="pendingCommentContent"
            id="comments-textarea"
            rows="4"
            class="w-full px-0 text-sm text-gray-700 bg-gray-50 border-0 focus:ring-0"
            placeholder="Write a comment..."
            required></textarea>
        } @else {
          <textarea
            [(ngModel)]="editCommentContent"
            id="comments-edit-textarea"
            rows="4"
            class="w-full px-0 text-sm text-gray-700 bg-gray-50 border-0 focus:ring-0"
            placeholder="Write a comment..."
            required></textarea>
        }
      </div>
    </div>
  </div>
  <div class="flex items-center justify-end px-3">
    @if (!editCommentId) {
      <button id="comments-post-btn"
              (click)="createComment()"
              [disabled]="!pendingCommentContent || loading()"
              type="submit"
              class="special-font disabled:bg-gray-400 inline-flex text-md items-center py-2 px-4 font-medium text-center text-white bg-[#91231c] rounded-lg hover:bg-[#B32B1F]">
        Post
      </button>
    } @else {
      <button id="comments-save-btn"
              [disabled]="!editCommentContent || loading()"
              (click)="editComment()"
              type="submit"
              class="special-font disabled:bg-gray-400 inline-flex text-md items-center py-2 px-4 font-medium text-center text-white bg-[#91231c] rounded-lg hover:bg-[#B32B1F]">
        Save
      </button>
      <button id="comments-cancel-btn"
              (click)="cancelEdit()"
              type="submit"
              class="special-font inline-flex text-md items-center py-2 px-4 ml-2 font-medium text-center text-white bg-[#91231c] rounded-lg hover:bg-[#B32B1F]">
        Cancel
      </button>
    }
  </div>
</div>

@if (loading()) {
  <loading-pulse [pulseCount]="9"/>
} @else {
  @if (data().length === 0) {
    <div id="comments-empty-state" role="status" class="w-full flex items-center justify-center p-4">
      No Comments found
    </div>
  } @else {
    <div id="comments-container" class="w-full mt-3">
      <div id="comments-list" class="overflow-x-auto">
        @for (item of data(); track item.comment_id; let idx = $index) {
          <div
            id="comment-item-{{idx}}"
            class="bg-white rounded-lg mb-3 group p-2 {{item.comment_id==editCommentId?'border border-blue-400':''}}">
            <div class="flex flex-col p-2">
              <div class="flex justify-between">
                <div class="flex align-bottom justify-between w-full">
                  <div class="flex gap-2 align-top items-end">
                    <avatar-icon [user]="getFirstAndLastNames(item.name)"/>
                    <div>
                      <div class="text-black font-bold text-normal flex flex-col">
                        <div class="flex">
                          <div class="flex justify-start items-end">
                            <div id="comment-author-{{idx}}" class="pr-1"> {{ item.name }}</div>
                            @if (item.role_name) {
                              <div id="comment-role-{{idx}}"
                                   class="flex ml-1 pr-2 pl-2 bg-[#fdde64] rounded-full h-fit text-sm pb-0.5"
                              > {{ item.role_name }}
                              </div>
                            }
                          </div>
                          <div id="comment-date-{{idx}}"
                               class="text-gray-800 font-normal ml-2 text-normal"> {{ item.date }}
                          </div>
                        </div>
                        <div id="comment-email-{{idx}}"
                             class="text-xs text-gray-600 {{item.email??'invisible'}}">{{ item.email ?? '--' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                @if (canEditComment(item) && !editCommentId) {
                  <div class="flex">
                    <button id="comment-edit-btn-{{idx}}"
                            (click)="startEditComment(item.comment_id,item.content)"
                            class="pl-2 pr-2 mr-1 invisible group-hover:visible">
                      <svg class="w-4 h-4 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                           fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="m10.8 17.8-6.4 2.1 2.1-6.4m4.3 4.3L19 9a3 3 0 0 0-4-4l-8.4 8.6m4.3 4.3-4.3-4.3m2.1 2.1L15 9.1m-2.1-2 4.2 4.2"/>
                      </svg>
                    </button>
                    <button id="comment-delete-btn-{{idx}}"
                            (click)="startDeleteComment(item.comment_id)"
                            class="pl-2 pr-2 invisible group-hover:visible">
                      <svg class="w-4 h-4 text-black" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                           fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
                      </svg>
                    </button>
                  </div>
                }
              </div>
              <div class="mt-2 mb-1 text-normal text-gray-800">
                <div class="pl-12">
                  <pre id="comment-content-{{idx}}" class="whitespace-pre-wrap break-words">{{ item.content }}</pre>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
}

<!-- Main modal -->
@if (commentToDeleteId) {
  <div
    class="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full backdrop-blur-xl">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <!-- Modal content -->
      <div id="comments-delete-modal-content" class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <!-- Modal header -->
        <div id="comments-delete-modal-header"
             class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
          <h3 id="comments-delete-modal-title" class="text-xl font-semibold text-gray-900 dark:text-white">
            Delete comment
          </h3>
          <button id="comments-delete-modal-close"
                  (click)="closeDeletionPopup()"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="static-modal">
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <!-- Modal body -->
        <div id="comments-delete-modal-body" class="p-4 md:p-5 space-y-4">
          <p class="text-gray-500 dark:text-gray-400">
            Are you sure you want to delete this comment?
          </p>
        </div>
        <!-- Modal footer -->
        <div id="comments-delete-modal-footer"
             class="flex items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
          <button id="comments-delete-confirm-btn"
                  (click)="deleteComment()"
                  data-modal-hide="static-modal"
                  type="button"
                  class="text-white bg-[#91231c] hover:bg-[#B32B1F] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
}
